module.exports = __webpack_public_path__ + "img/keyboard-light.364f841c.jpg";